import { Component, OnInit } from '@angular/core';
import { Testimonials } from '../../../_data/testimonials';
import { TestimonialsExpand } from '../../../_services/animations';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss'],
  animations: [TestimonialsExpand],
})
export class TestimonialsComponent implements OnInit {
  Testimonials = Testimonials;
  Expand = 'default';

  constructor() {}

  ngOnInit() {}

  expand() {
    switch (this.Expand) {
      case 'default':
        this.Expand = 'more';
        break;
      case 'more':
        this.Expand = 'all';
        break;
      default:
        this.Expand = 'default';
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/testimonials/testimonials.component.ts